import React from 'react';
import moment from 'moment';

const formatters = {
    U_ShiftType: (value) => {
        return value === 'O'
            ? 'Corte Abierto'
            : value === 'C'
                ? 'Corte Cerrado'
                : '--';
    },

    U_Status: (value, row) => {
        if (value === 'P') return 'Pendiente';
        if (value === 'R') return 'Reasignado';

        if (value === 'C') {
            // Diferenciar Aceptado vs Cerrado
            return row?.U_Accepted === 'Y'
                ? 'Aceptado'
                : 'Cerrado';
        }
        return '--';
    },

    U_CreateDate: (value) => {
        return value ? moment.utc(value).format('DD/MM/YYYY') : '--';
    },

    U_AcceptDate: (value) => {
        return value ? moment.utc(value).format('DD/MM/YYYY') : '--';
    }
};

const renderHeader = (headers) => (
    <tr>
        {headers?.filter(h => h.active)?.map((h, index) => (
            <th
                key={index}
                style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
            >
                {h.title}
            </th>
        ))
        }

        <th
            className="sticky-columns"
            style={{ backgroundColor: "#e9ecef", textAlign: 'center', whiteSpace: 'nowrap' }}
        >
            Acciones
        </th>
    </tr>
);

const renderTableBody = (headers, data, openDetails) => {

    const activeHeaders = (headers || []).filter(h => h.active);

    if (!data?.length) {
        return (
            <></>
        );
    }

    return data.map((row, index) => (
        <tr key={index}>
            {activeHeaders?.map((h, i) => {
                let value = row[h.key];

                // Aplicar formatter si existe
                if (formatters[h.key]) {
                    value = formatters[h.key](row[h.key], row);
                }

                return (
                    <td
                        key={i}
                        style={{
                            textAlign: 'center',
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {value ?? ''}
                    </td>
                );
            })}

            {/* ACCIONES */}
            <td
                className="sticky-columns"
                style={{
                    backgroundColor: "#e9ecef",
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}
            >
                <button
                    type="button"
                    className="btn btn-timbra-one btn-sm botonCorrect"
                    onClick={() => openDetails(row)}
                    style={{ fontWeight: '500' }}
                >
                    <i className="far fa-file-alt"></i> Ver Detalles
                </button>
            </td>
        </tr>
    ));
};

const renderTable = (headers, data, openDetails) => {

    return (
        <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
            <thead className="table-header">
                {renderHeader(headers)}
            </thead>
            <tbody>
                {renderTableBody(headers, data, openDetails)}
            </tbody>
        </table>
    );
};

export const renderCutTransfers = (headers, data, checkbox, openDetails) => {
    return renderTable(headers, data, openDetails);
};